import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/relist-mercari';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari Seller Secret: Relist your old Listings!</title>
        <meta
          name='description'
          content="Learn here all you need to know about relisting to boost an unsold item's appeal and salability on the platform."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/relist-mercari' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/relist-mercari' />
        <meta property='og:title' content='Mercari Seller Secret: Relist your old Listings!' />
        <meta
          property='og:description'
          content="Learn here all you need to know about relisting to boost an unsold item's appeal and salability on the platform."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
